import { render, staticRenderFns } from "./InsurerPage.vue?vue&type=template&id=7577f1a1&"
import script from "./InsurerPage.vue?vue&type=script&lang=js&"
export * from "./InsurerPage.vue?vue&type=script&lang=js&"
import style0 from "./InsurerPage.vue?vue&type=style&index=0&id=7577f1a1&prod&lang=scss&style=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports